import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Heading } from '../styles/Heading';
import { color, size } from '../styles/helpers/variables';
import { NoStyleLink } from '../styles/NoStyleLink';
import { shadowOnHover } from '../styles/helpers/mixins';

const PageListItem = props => {
  const itemTitle = props.title.replace(new RegExp(props.searchQuery, 'gi'), p1 => `<span>${p1}</span>`);
  const itemDescription = props.description.replace(new RegExp(props.searchQuery, 'gi'), p1 => `<span>${p1}</span>`);

  return (
    <Root>
      <NoStyleLink to={props.url}>
        <PageListItemContainer>
          <PageListItemTitle dangerouslySetInnerHTML={{ __html: itemTitle }} />
          <PageListItemDescription dangerouslySetInnerHTML={{ __html: itemDescription }} />
        </PageListItemContainer>
      </NoStyleLink>
    </Root>
  );
};

const Root = styled.div`
  margin: 15px 0;
  ${shadowOnHover};

  @media screen and (min-width: ${size.xLarge}px) {
    margin: 30px 0;
  }
`;

const PageListItemContainer = styled.div`
  width: 100%;
  background: ${color.white};
  padding: 22px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media screen and (min-width: ${size.xLarge}px) {
    padding: 40px 100px 40px 40px;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`;

const PageListItemTitle = Heading.extend`
  z-index: 1;
  @media screen and (min-width: ${size.xLarge}px) {
    padding-right: 1em;
  }
  span {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 90%;
      opacity: 0.5;
      background-color: #d3d3d3;
      z-index: -1;
    }
  }
`;

const PageListItemDescription = styled.p`
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: ${color.black};
  margin: 0;
  z-index: 1;

  span {
    font-weight: 600;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      right: -0.1em;
      bottom: 0;
      left: -0.1em;
      height: 90%;
      opacity: 0.5;
      background-color: #d3d3d3;
      z-index: -1;
    }
  }

  @media screen and (min-width: ${size.xLarge}px) {
    font-size: 20px;
    max-width: 60%;
  }
`;

PageListItem.defaultProps = {
  title: '',
  description: '',
  url: '',
  searchQuery: null
};

PageListItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  searchQuery: PropTypes.string
};

export default PageListItem;



// WEBPACK FOOTER //
// ./src/components/PageListItem.js